import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function LoginPage({ setIsAuthenticated, setUsername }) {
    const [usernameInput, setUsernameInput] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const isLoggedIn = sessionStorage.getItem('isAuthenticated');
        if (isLoggedIn) navigate('/vehicles');
    }, []);

    const handleLogin = e => {
        e.preventDefault();
        if (usernameInput === 'admin' && password === 'password123') {
            sessionStorage.setItem('isAuthenticated', 'true');
            sessionStorage.setItem('username', usernameInput);
            setIsAuthenticated(true);
            setUsername(usernameInput);
            navigate('/vehicles');
        } else {
            setError('Invalid username or password');
        }
    };

    return (
        <div className="container mt-5" style={{ maxWidth: '400px' }}>
            <h3 className="mb-3">Login to Vehicle Manager</h3>
            <form onSubmit={handleLogin}>
                <div className="mb-3">
                    <label className="form-label">Username</label>
                    <input type="text" className="form-control" value={usernameInput}
                        onChange={e => setUsernameInput(e.target.value)} required />
                </div>
                <div className="mb-3">
                    <label className="form-label">Password</label>
                    <input type="password" className="form-control" value={password}
                        onChange={e => setPassword(e.target.value)} required />
                </div>
                {error && <div className="alert alert-danger">{error}</div>}
                <button type="submit" className="btn btn-primary w-100">Login</button>
            </form>
        </div>
    );
}
